import React,{useEffect} from 'react'
import './WhatWeAre.css'
import CommonHeadingBottomLine from '../../Common-Component/CommonHeadingBottomLine/CommonHeadingBottomLine'
import { getWhat_We_Are } from '../../../features/aboutus/aboutusSlice';
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser";

const WhatWeAre = () => {
    const whatweare = useSelector((state) => state.aboutus.addWhatWeAre);
    const dispatch = useDispatch();
    
  
    useEffect(() => {
      dispatch(getWhat_We_Are());
    }, [dispatch]);
  
    

    return (
        <section className='WhatWeAre'>

            <div className='title_div'>
                <CommonHeadingBottomLine headingText="What We Are" />
            </div>

            <div className='content_holder'>

                <div className='background_holder'></div>

                {whatweare && whatweare.length > 0 ? (
                    whatweare?.map((item, index) => (
                        <div className='row' key={index}>
                            <div className='col-md-6 col-sm-12 col-12'>
                                <div className='text_holder_div'>
                                <p className="info_descn">{parse(item.description) || ""}</p>
                                </div>
                            </div>
                            <div className='col-md-6 col-sm-12 col-12'>
                                <div className='img_holder'>
                                    <img  src={process.env.REACT_APP_IMG_URL + item?.image} alt='What We Are' className='bg_img' />
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        </section>
    )
}

export default WhatWeAre
